import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatLegacyFormFieldModule as MatFormFieldModule } from '@angular/material/legacy-form-field';
import { MatLegacySelectModule as MatSelectModule } from '@angular/material/legacy-select';
import { MatLegacySlideToggleModule as MatSlideToggleModule } from '@angular/material/legacy-slide-toggle';

import { CommentSettingsSelectionModule } from '@app/src/app/components/CommentSettingsSelection';
import { MgDateTimePickerModule } from '@app/src/app/date-time-picker';
import { MgFormFieldModule } from '@app/src/app/form-field';
import { PermissionsModule } from '@app/src/app/permissions';
import { MultiSelectRoleModule } from '@app/src/app/roles/components/MultiSelectRole';

import { FormModule } from '../../shared/components/form';
import { DayjsPipesModule } from '../../shared/pipes/dayjs/dayjs-pipes.module';
import { ContentPublishControlsComponent } from './ContentPublishControls.component';

@NgModule({
  imports: [
    // Minga dependencies
    MgDateTimePickerModule,
    PermissionsModule,
    MgFormFieldModule,
    MultiSelectRoleModule,
    CommentSettingsSelectionModule,

    FormModule,
    DayjsPipesModule,
    // External dependencies
    CommonModule,
    FormsModule,
    MatFormFieldModule,
    MatSlideToggleModule,
    MatSelectModule,
  ],
  declarations: [ContentPublishControlsComponent],
  exports: [ContentPublishControlsComponent],
})
export class ContentPublishControlsModule {}
